<template>
  <header id="header" class="mobile">
    <h1 id="logo">
      <img src="../../../assets/mobile/images/logo.png" alt="문화셈터">
      <p>모바일 지도통계서비스</p>
    </h1>
    <button type="button" class="btn--search" @click="openModal()" >
      <img src="../../../assets/mobile/images/search.png" alt="검색하기">
    </button>
  </header>
</template>

<script>
import ModalView from '@/layout/mobile/components/ModalView'
export default {
  name: "Header",
  methods: {
    openModal() {
      this.$FModal.show(
        {
          component: ModalView,
          contentStyles: {
            padding: '50px 10px 0 10px',
            overflow: 'hidden',
            borderRadius: '25px 25px 0 0 !important',
          },
          maxHeight: '90%'
        }
      )
    }
  }
}
</script>
